import type { Macros } from "../lib/types";

export function MacroBar({ macros }: { macros?: Macros }) {
  if (!macros) return null;
  const cell = (label: string, v: number | undefined, unit: string, accent = false) =>
    v == null ? null : (
      <div className="cell" key={label}>
        <div className={"v " + (accent ? "" : "fg")}>
          {v}
          <sup>{unit}</sup>
        </div>
        <div className="k">{label}</div>
      </div>
    );
  return (
    <div className="macros">
      {cell("Calories", macros.calories, "kcal")}
      {cell("Protein", macros.protein, "g", true)}
      {cell("Carbs", macros.carbs, "g")}
      {cell("Fat", macros.fat, "g")}
      {cell("Fiber", macros.fiber, "g")}
    </div>
  );
}
